export default "__VITE_ASSET__xNwtf6Qp__"